import * as d3 from "d3";
import { numberOfVisualizations } from "../settings.js";

/**
 * merges all visualizations into one SVG
 */
export const mergeSVGs = () => {
    let svgList = collectSVGs()
    let svgCumulativeHeightList = [0]
    let mergedHeight = 0

    for (let svg of svgList) {
        let currentHeight = svg.viewBox.baseVal.height * 0.75
        mergedHeight += currentHeight
        svgCumulativeHeightList.push(mergedHeight)
    }

    var svgNS = "http://www.w3.org/2000/svg";
    let mergedSVG = document.createElementNS(svgNS, 'svg');
    mergedSVG.setAttributeNS(null, "id", "cloned-svg-0");
    mergedSVG.setAttributeNS(null, "viewBox", "0 0 750 " + mergedHeight);
    mergedSVG.setAttributeNS(null, "width", "100%");
    mergedSVG.setAttributeNS(null, "height", "100%");
    mergedSVG.setAttributeNS(null, "preserveAspectRatio", "xMinYMin meet");


    for (let i = 0; i < svgList.length; i++) {
        svgList[i].setAttributeNS(null, "x", 0)
        svgList[i].setAttributeNS(null, "y", svgCumulativeHeightList[i])
        svgList[i].setAttributeNS(null, "preserveAspectRatio", "xMinYMin meet");
        mergedSVG.appendChild(svgList[i])
    }
    return mergedSVG
}

/*
 * collect a list of svgs with id svg-N
 */
function collectSVGs() {
    let svgList = []
    for (let i = 1; i < numberOfVisualizations + 1; i++) {
        let clonedSVG = clone("#svg-" + i, true)
        svgList.push(clonedSVG)
    }
    return svgList
}

/**
 * 
 * @param {*} selector id of SVG Element
 * @param {*} merged part of the merged SVG
 * simple clone has the modified id cloned-N, mergecloned-N id part of the merged svg 
 */
export const clone = (selector, merged) => {
    let merge = merged ? "merge" : ""
    var node = d3.select(selector).node()
    var clone = node.cloneNode(true)
    // remove namespace reference as it breaks png export
    clone.removeAttribute('xmlns');
    clone.removeAttribute('xmlns:xlink');
    clone.setAttributeNS(null, "id", merge + "cloned-" + selector.substring(1))
    return clone
}

